import { getAxiosClient } from "../../axios-client";
import { AddWarehousesImagesBody, AddWarehousesImagesResponse } from "./types";

const axiosClient = getAxiosClient();
export const addWarehousesImage = async (body: AddWarehousesImagesBody) => {
    return await axiosClient.ax
    .post<AddWarehousesImagesResponse>("/WarehousesImages/AddImage", body,{headers: {'content-type': 'multipart/form-data'}})
  };
  
